import { combineReducers } from 'redux';
import userAuth from './userAuth';
import uiSettings from './ui';
import sensors from './sensors';
import locations from './location';
import alerts from './alerts';

export default combineReducers({ userAuth, uiSettings, sensors, locations, alerts });
